// extracted by mini-css-extract-plugin
export default {"person":"UeberUns_person__IWT1g"};